import { AutocompleteCloseReason } from '@mui/material/Autocomplete';
import { SyntheticEvent } from 'react';
import { ControllerFieldState } from 'react-hook-form';
import { FreightType } from '../../../../../../../types/Enums';
import { blurActiveElement } from '../../../../../../../utils/viewport.utils';
import { OrderConditionFieldWithError } from '../../../../../conditions/orderConditionFieldErrors.map';
import { OrderTransportCondition } from '../../../../../order.types';

interface IsShippingCompanyVisibleParams {
  brandFreightTypeCode?: string | null;
  orderTransportCondition: OrderTransportCondition;
}

export const isShippingCompanyVisible = ({
  brandFreightTypeCode,
  orderTransportCondition,
}: IsShippingCompanyVisibleParams) =>
  orderTransportCondition === OrderTransportCondition.FREIGHT_TYPE_AND_SHIPPING_COMPANY &&
  brandFreightTypeCode !== FreightType.NO_TRANSPORT_OCCURENCE;

const CONDITION_FIELD_MIN_WIDTH = 200;
const CONDITION_FIELDS_GAP = 16;

export const CONDITION_FIELDS_TWO_COLUMNS_MIN_WIDTH =
  CONDITION_FIELD_MIN_WIDTH * 2 + CONDITION_FIELDS_GAP;

export const getConditionFieldsGridSx = (hasTwoFields: boolean, containerWidth: number) => ({
  display: 'grid',
  gap: 2,
  gridTemplateColumns:
    hasTwoFields && containerWidth >= CONDITION_FIELDS_TWO_COLUMNS_MIN_WIDTH
      ? 'repeat(2, minmax(0, 1fr))'
      : '1fr',
});

export const hasFieldError = (
  fieldState: ControllerFieldState,
  fieldsWithError: Set<OrderConditionFieldWithError>,
  name: OrderConditionFieldWithError,
) =>
  !!fieldState.error || (fieldsWithError.has(name) && (fieldState.isDirty || fieldState.isTouched));

export const blurAutocompleteOnPointerSelect = (
  event: SyntheticEvent,
  reason?: AutocompleteCloseReason,
) => {
  if (reason === 'selectOption' && event.type !== 'keydown') {
    blurActiveElement();
  }
};
